import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/common/base/base.service';
import { RsswaService } from 'src/app/components/rsswa/rsswa.service';
import { LogForm } from '../../form-history-services/form-history.service';
import { IFormHistoryService } from '../../form-history-services/i-form-history-service';
import { RSSWAResource } from 'src/app/components/rsswa/rsswa';
import { FormHistoryServicesHelper } from '../../form-history-services/form-history-services-helper';

@Injectable({
  providedIn: 'root'
})
export class FormHistoryRsswaService extends BaseService<any, number> implements IFormHistoryService {

  amendmentSectionNumber = 9;
  helper = FormHistoryServicesHelper;

  constructor(
    protected override injector: Injector,
    private service: RsswaService
  ) {
    super(injector, '');
  }

  async processForm(form: any, logForm: LogForm, rsswa: RSSWAResource) {
    // const rsswa = (await this.service.getById(form.id).toPromise()) as RSSWAResource;

    form.createdByName = this.users?.find(u => u.id === form.createdBy)?.name;
    form.requesterName = this.users?.find(u => u.id === form.requesterId)?.name;

    logForm.updates = this.processUpdates(logForm, rsswa);
    logForm.originalBody = form;
    return logForm;
  }

  processUpdates(logForm: LogForm, rsswa: RSSWAResource) {
    // ---- Amendments list ----
    const wfSignatures = rsswa?.wfTable?.wfTableLocal
      ?.wfSectionLocals.find(s => s.number === this.amendmentSectionNumber)
      ?.wfSignatures
      ?.filter(s => s.taskID !== 0) ?? [];

    const amendmentsSet = new Set<number>(this.helper.getAmendmentList(logForm.signatures ?? []));

    // ---- Updates ----
    const updates = logForm?.updates ?? [];

    updates?.forEach(update => {
      // Parse old body
      if (update.prevBodyJson) {
        const prev = this.helper.createBody(update.prevBodyJson, this.users);
        const current = this.helper.createBody(update.currentBodyJson ?? '', this.users);

        prev.rsswaAmendment = current;
        update.currentBody = prev;
        if (update.amendmentId && amendmentsSet)
          update.header = this.helper.getLogHeadText(update.amendmentId, amendmentsSet);
      }
    });

    return updates;
  }

}
